import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "最新大片 · 高分经典",
    count: "12,860 部",
    bg: "bg-primary-50",
    ring: "border-primary-100",
    icon_bg: "bg-primary-600 text-background-50",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 全集在线",
    count: "8,420 部",
    bg: "bg-secondary-50",
    ring: "border-secondary-100",
    icon_bg: "bg-secondary-600 text-background-50",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "最新资讯",
    desc: "影视新闻 · 深度评论",
    count: "每日更新",
    bg: "bg-accent-50",
    ring: "border-accent-100",
    icon_bg: "bg-accent-500 text-primary-950",
  },
];

export default function QuickEntries() {
  return (
    <div className="mx-auto -mt-10 max-w-site px-4 md:px-6">
      <div className="relative z-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.title}
            to={entry.to}
            className={`group flex items-center gap-4 rounded-lg border ${entry.ring} ${entry.bg} p-5 transition-all duration-300 hover:-translate-y-1`}
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${entry.icon_bg}`}
            >
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {entry.title}
                </h3>
                <i className="ri-arrow-right-line text-foreground-400 transition-transform duration-300 group-hover:translate-x-1"></i>
              </div>
              <p className="mt-0.5 truncate text-xs text-foreground-500">{entry.desc}</p>
              <p className="mt-1 text-xs font-medium text-primary-700">{entry.count}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}